import React from "react";
import Modal from "../../../../components/elements/Modal";
import ManageUser from "../ManageUser.js";
import Drawer from "../../../../components/elements/Drawer.js";
import DrawerHeader from "../../../../components/elements/DrawerHeader.js";

const ManageUserModal = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    // <Modal
    //   isOpen={open}
    //   setIsOpen={close}
    //   size="xl2"
    //   title={data?._id ? "Update" : "Create New "}
    // >
    //   <ManageUser getResponse={getResponse} close={close} data={data} />
    // </Modal>

    <Drawer
      open={open}
      onClose={(val) => {
        close(val);
      }}
      actualSize={"xl5"}
      size={"xl5"}
      title={data?._id ? "Update" : "Create New "}
      subtitle="Create, View, update and modify user details and information bellow"
      drawerBodyClass="p-0 max-h-[calc(100%-42px)]"
      // header={<DrawerHeader />}
    >
      <ManageUser getResponse={getResponse} close={close} data={data} />
    </Drawer>
  );
};

export default ManageUserModal;
